import styled from 'styled-components'

export const BannerWrapper = styled.div`
	width: 100%;
	overflow: hidden;
`

export const BannerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 1700px;
	margin: 0 auto;
	padding: 24px 16px;

	@media(max-width: 768px){
	 padding: 5px;
	}
`

export const BannerDecor = styled.img`
	flex: 1 1 50%;
	min-width: 0;
	width: 100%;
	height: auto;
	object-fit: contain;

	@media(max-width: 530px){
		position: relative;
		max-width: 410px;
	}
`

export const BannerTextBlock = styled.div`
	flex: 1 1 50%;
	min-width: 0;
	width: 100%;

	@media(max-width: 530px){
	 position: absolute;
	 max-width: 260px;
	 top: 310px;
     right: 0;
	}
`

export const TextBlockHeading = styled.div`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 400;
	font-size: 48px;
	color: #555;
	margin-bottom: 20px;

	span {
		font-size: 65px;
		letter-spacing: 0.01em;
		text-transform: uppercase;
		background: linear-gradient(
			90deg,
			#1d6511 0%,
			#2d7022 38.46%,
			#1b640f 100%
		);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	@media (max-width: 1024px) {
		font-size: 26px;
		span {
			font-size: 36px;
		}
	}

	@media (max-width: 768px) {
	    margin-bottom: 10px;
		font-size: 20px;
		span {
			font-size: 27px;
		}
	}
`

export const TextBlockActions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: 320px;

	@media (max-width: 1024px) {
		max-width: 235px;
	}
`
